import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';

@Component({
  selector: 'app-site-ppe',
  templateUrl: './site-ppe.component.html',
  styleUrls: ['./site-ppe.component.scss']
})
export class SitePpeComponent implements OnInit {

  title = '';

  constructor(
    public dialogRef: MatDialogRef<SitePpeComponent>,
    @Inject(MAT_DIALOG_DATA) public info: any,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.title = this.info.title;
    document.getElementById('msg').innerHTML = decodeURIComponent(this.info.message).replace(/\+/g, ' ').replace(/\r/g, '<br />');
  }

  closeDialog() {
    this.dialogRef.close({});
  }

}
